(function () {
  // Grab all digits and join them: "$5,000" -> "5000", "5.000 kr" -> "5000"
  function parseIntLoose(str) {
    if (!str) return 0;
    var parts = String(str).match(/\d+/g);
    if (!parts) return 0;
    var n = Number(parts.join(''));
    return Number.isFinite(n) ? n : 0;
  }

  function updateProgress(container) {
    if (!container) return;

    var bar = container.querySelector('.rivo-account-progress-bar');
    var subtitle = container.querySelector('.rivo-vip-tier-progress-description-subtitle');

    var currentThresholdEl = container.querySelector(
      '.rivo-account-progress-current-tier-label-container .rivo-progress-current-tier-label'
    );
    var nextThresholdEl = container.querySelector(
      '.rivo-account-progress-next-tier-label-container .rivo-progress-next-tier-label'
    );

    // This value is usually wrapped in .money inside the subtitle
    var leftEl = container.querySelector(
      '.rivo-vip-tier-progress-description-subtitle .money'
    ) || subtitle;

    if (!bar || !currentThresholdEl || !nextThresholdEl || !leftEl) return;

    var currentThreshold = parseIntLoose(currentThresholdEl.textContent);
    var nextThreshold = parseIntLoose(nextThresholdEl.textContent);
    var leftToEarn = parseIntLoose(leftEl.textContent);

    var range = Math.max(1, nextThreshold - currentThreshold);
    var earnedInRange = Math.max(0, range - leftToEarn);
    var pct = Math.max(0, Math.min(100, (earnedInRange / range) * 100));

    // Optional minimum visible width (but not when 0)
    var pctForWidth = (pct > 0 && pct < 7) ? 7 : pct;

    // Avoid writing if nothing changed (reduces DOM churn)
    var pctText = Math.round(pct) + '%';
    var last = bar.getAttribute('data-rivo-fixed-pct');
    if (last === pctText) return;

    bar.setAttribute('data-rivo-fixed-pct', pctText);
    bar.style.setProperty('width', pctForWidth.toFixed(2) + '%', 'important');
    bar.textContent = pctText;

    // Optional: change “Spend” -> “Earn” in subtitle
    if (subtitle && !subtitle.getAttribute('data-rivo-fixed-copy')) {
      subtitle.innerHTML = subtitle.innerHTML.replace(/\bSpend\b/i, 'Earn');
      subtitle.setAttribute('data-rivo-fixed-copy', '1');
    }
  }

  function run() {
    var containers = document.querySelectorAll('.rivo-vip-tier-progress-container');
    for (var i = 0; i < containers.length; i++) updateProgress(containers[i]);
  }

  // Debounced observer to prevent loops
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      // Disconnect while we write to DOM to avoid feedback loops
      observer.disconnect();
      try {
        run();
      } finally {
        observer.observe(document.documentElement, { childList: true, subtree: true });
      }
    });
  });

  // Initial run
  run();
  window.addEventListener('load', run);

  // Observe for Rivo re-renders
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
